module.exports = __webpack_public_path__ + "static/bugzilla-15df9edd746f52df459f86de7792e65b.svg";